// extracted by mini-css-extract-plugin
var _1 = "AbsolutePortal_binding__4a186";
var _2 = "AbsolutePortal_children__ce6bb";
var _3 = "AbsolutePortal_measure__3dae7";
var _4 = "AbsolutePortal_portal__99fa9";
var _5 = "AbsolutePortal_root__0f039";
export { _1 as "binding", _2 as "children", _3 as "measure", _4 as "portal", _5 as "root" }
